import type { ReactNode } from 'react'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

type PageProps = {
  children: ReactNode
}

const Root = ({ children }: PageProps) => (
  <div className="flex flex-col gap-6 md:gap-2">{children}</div>
)

type HeaderProps = {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}

const Header = ({ title, subtitle, actions }: HeaderProps) => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <Typography
          component="h1"
          variant={isSmAndLower ? 'h5' : 'h4'}
        >
          {title}
        </Typography>
        {subtitle != null && (
          <Typography
            color="text.secondary"
            variant="body2"
          >
            {subtitle}
          </Typography>
        )}
      </div>
      {actions}
    </div>
  )
}

type ContentProps = {
  children: ReactNode
}

const Content = ({ children }: ContentProps) => (
  <div className="flex flex-col gap-3">{children}</div>
)

export const Page = Object.assign(Root, {
  Header,
  Content,
})
